import BaseUIMkpProductLinkManagerView from 'xui/modules/product/BaseUIMkpProductLinkManagerView'

export default class MkpProductLinkManagerView extends BaseUIMkpProductLinkManagerView {
  static displayName = 'MkpProductLinkManagerView'
}
